export default __webpack_public_path__ + "static/media/loading.1a32f552.gif";